import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class DisabledOwnersApi {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  public createRestriction(body: {
    provider?: string;
    gameOwnerName: string;
    localeId: number;
  }): CancelablePromise<void> {
    if (body.provider === undefined) {
      body.provider = '';
    }

    return this.httpRequest.request({
      method: 'POST',
      mediaType: 'application/json',
      url: '/locale-disabled-owners',
      body,
    });
  }

  public deleteByProviderLocale(query: {
    aggregator: string,
    provider: string;
    localeId: number,
  }): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/locale-disabled-owners/delete-by-provider-locale',
      query,
    });
  }
}
